






















import { Prop, Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Mixin from '../mixin';
import OrgInfo from '../class/OrgInfo';
@Component
export default class QRCodeTable extends Mixin {
  @State private group!: any;
  @State private showOrg!: string;
  private idlist: any[] = [];
  private sort: boolean = false;

  private mounted() {
    this.idlist = (this.$route.query.ids as string).split(',').map((id: string) => {
      let name = '';
      for (const g of this.group[this.showOrg]) {
        if (g.ID === id) {
          name = g.Name;
          break;
        }
      }
      return { id, name };
    });
  }

  private sortList() {
    this.sort = !this.sort;
    this.idlist.sort((a, b) => {
      return (this.sort ? a.name < b.name : b.name < a.name) ? -1 : 1;
    });
  }

  private print() {
    window.print();
  }
}
